import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import classes from './Root.module.scss';

import LogoDark from '../../assets/logo-dark.svg';
import TmcLogo from '../../assets/tmc-logo.svg';
import FlitzLogo from '../../assets/flitz-logo.svg';
import { MdMenu } from "react-icons/md";
import { AiFillInstagram, AiFillLinkedin } from "react-icons/ai";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link, ScrollRestoration } from 'react-router-dom';

import ThemeBtn from '../../components/UI/ThemeBtn';
import { Outlet } from "react-router-dom";
import Toast from "../../components/UI/toast";
import FooterBg from '../../assets/icons/FooterBg.svg';

import { FLITZ_URL } from '../../constants/paths';

const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_US_EMAIL || 'hello@flitz.ai';
const FLITZ_HOME = 'https://flitz.ai';
const FLITZ_LOGIN = 'https://flitz.ai/login';
const FLITZ_INSTAGRAM = 'https://www.instagram.com/flitz.ai';
const FLITZ_LINKEDIN = 'https://www.linkedin.com/company/flitz-ai';
const TMC_HOME = 'https://ctotmc.com';

const RootLayout = () => {
  const [showMenu, setShowMenu] = useState(false);

  const handleMenuClose = () => setShowMenu(false);
  const handleMenuShow = () => setShowMenu(true);

  const goToRegister = () => {
    window.location.href = FLITZ_URL;
  }

  const goToLogin = () => {
    window.location.href = FLITZ_LOGIN;
  }

  return (
    <Container fluid className="g-0">
      <Row className={`g-0 ${classes.header}`}>
        <Col lg={1} className="my-4 d-none d-lg-block"></Col>
        <Col lg={6} md={6} xs className="my-4">
          <Link to="/"><img src={LogoDark} alt="JobApply24" className={`${classes.logo} ms-4`} /></Link>
        </Col>
        <Col lg={4} md={6} xs className="my-4">
          <div className={`float-end me-4 ${classes.btnContainer}`}>
            <ThemeBtn text="Login" className="me-2" onClick={goToLogin} />
            <ThemeBtn text="Register" variant="primary" onClick={goToRegister} />
          </div>
          <div className={`float-end me-4 ${classes.menuIconContainer}`}>
            <button><MdMenu className={classes.menuIcon} onClick={handleMenuShow} /></button>
          </div>
        </Col>
        <Col lg={1} className="my-4 d-none d-lg-block"></Col>

        <Offcanvas show={showMenu} onHide={handleMenuClose} placement="top">
          <Offcanvas.Header closeButton className={classes.mainMenuHead}>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className={classes.mainMenuItemWrapper}>
              <div><a onClick={handleMenuClose} href={FLITZ_LOGIN}>Login</a></div>
              <div><a onClick={handleMenuClose} href={FLITZ_URL}>Register</a></div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </Row>

      <main>
        <Outlet />
      </main>

      <div className={classes.footer}>
        <div className={classes.footerTop} style={{
            backgroundImage: `url(${FooterBg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}>
          <h2>Ready to build your next CV?</h2>
          <p>Bring your whole career into one profile and let CV Studio tailor it to every job — on Flitz.</p>
          <ThemeBtn text="Get Started" variant="primary" onClick={goToRegister} />
        </div>
        <div className={classes.footerBottom}>
          <Row className='g-0'>
            <Col lg={1}></Col>
            <Col lg={10}>
              <div className={classes.ftLinksContainer}>
                <div className={classes.ftLogoContainer}>
                  <Link to="/"><img src={LogoDark} alt="JobApply24" className={classes.ftLogo} /></Link>
                </div>
                <a className={classes.ftLink} href={FLITZ_HOME} target="_blank" rel="noreferrer">Flitz.ai</a>
                <Link className={classes.ftLink} to='/terms-of-service'>Terms of service</Link>
                <Link className={classes.ftLink} to='/privacy-policy'>Privacy policy</Link>
                <a className={classes.ftLink} href={`mailto:${CONTACT_EMAIL}`}>Contact us</a>
                <div className={classes.ftSocials}>
                  <a href={FLITZ_INSTAGRAM} target="_blank" rel="noreferrer" aria-label="Flitz on Instagram"><AiFillInstagram /></a>
                  <a href={FLITZ_LINKEDIN} target="_blank" rel="noreferrer" aria-label="Flitz on LinkedIn"><AiFillLinkedin /></a>
                </div>
              </div>
              <div className={classes.ftSubBar}>
                <a className={classes.ftFlitz} href={FLITZ_HOME} target="_blank" rel="noreferrer">
                  <img src={FlitzLogo} alt="" />
                  <span className={classes.ftFlitzName}>Flitz<span>.ai</span></span>
                </a>
                <a className={classes.ftByTmc} href={TMC_HOME} target="_blank" rel="noreferrer">
                  <span>A product of</span>
                  <img src={TmcLogo} alt="The Mejlerö Company" />
                  <span>The Mejlerö Company</span>
                </a>
                <span className={classes.ftCopy}>Made in Switzerland · © 2026 Flitz.ai</span>
              </div>
            </Col>
            <Col lg={1}></Col>
          </Row>
        </div>
      </div>
      <Toast />
      <ScrollRestoration />
    </Container>
  )
}

export default RootLayout;
